/**
 * Initialize partner module
 *
 * @param {HTMLElement} root
 */
const init = (root) => {
	root.classList.add('initialized');

	const slideDuration = parseInt(root.dataset.slideDuration);
	const testimonialItems = root.querySelectorAll('.js-testimonial');
	const testimonialItemsLength = testimonialItems.length;

	let currentItem = 0;

	if (testimonialItemsLength > 1) {
		setInterval(function () {
			testimonialItems.forEach((item, key) => item.classList.toggle('active', key === currentItem));

			currentItem++;
			if (currentItem >= testimonialItemsLength) {
				currentItem = 0;
			}
		}, slideDuration);
	}

	// Function to set the same height for testimonial items
	const setSameHeight = () => {
		let maxHeight = 0;
		testimonialItems.forEach((item) => {
			item.style.height = 'auto'; // Reset height to auto before recalculating
			const itemHeight = item.offsetHeight;
			if (itemHeight > maxHeight) {
				maxHeight = itemHeight;
			}
		});
		testimonialItems.forEach((item) => {
			item.style.height = `${maxHeight}px`; // Set the same height for each item
		});
	};

	// Call setSameHeight on page load and resize
	window.addEventListener('load', setSameHeight);
	window.addEventListener('resize', setSameHeight);
};

export const initTestimonialsModule = (root = document) => {
	const testimonialsModules = root.querySelectorAll('.js-testimonials:not(.initialized)');

	Array.from(testimonialsModules).forEach((root) => {
		init(root);
	});
};
